import {
  APP_TYPE_ENUM,
  TAG_STATUS_TYPES_ENUM,
} from "@/common/globalTypes/enums/common";
import { type IApplicationByAliasResponse } from "@/services/apiHandlers/applications/types";

export const applicationQueryKey = "applicationQueryKey";

export const applicationByAliasDefaultValues: IApplicationByAliasResponse = {
  id: "",
  logo: "",
  price: 0,
  formattedMonthlyPrice: "",
  formattedPrice: "",
  oauthClientId: "",
  monthlyPrice: 0,
  reviewsCount: "0",
  name: "",
  alias: "",
  logoUrl: "",
  averageRating: 1,
  benefits: [],
  position: 0,
  trialDays: 0,
  details: [],
  categories: [],
  createdAt: "",
  updatedAt: "",
  description: "",
  isInstalled: false,
  developer: "",
  rating: 0,
  version: "",
  billingFrequency: 0,
  galleryItems: [],
  documentationUrl: "",
  status: TAG_STATUS_TYPES_ENUM.LIVE,
  type: APP_TYPE_ENUM.NATIVE,
};
